import { getByteLen, isEmpty, formatDate } from '@/common/js/utils'

function validateName(rule, value, callback) {
  const { plan_name } = this.innerForm
  if (!plan_name) {
    callback(new Error('请输入计划组名称'))
  }
  const len = getByteLen(plan_name)
  if (len > 80) {
    callback(new Error('最大80个字符，1个中文等于2个字符'))
  }
  callback()
}
function validateCampaignId(rule, value, callback) {
  const { campaign_id } = this.formData
  if (!campaign_id) {
    return callback(new Error('请选择计划名称'))
  }
  callback()
}

function validateLandingPage(rule, value, callback) {
  const { externalUrls, page_type_custom } = this.outterForm
  const { land_page_id } = this.innerForm
  // 快手建站落地页
  if (page_type_custom === 1) {
    if (!externalUrls?.length) {
      callback(new Error('请选择落地页'))
    }
  }
  // 平头哥落地页
  if (page_type_custom === 2) {
    if (!land_page_id) {
      callback(new Error('请选择落地页'))
    }
  }
  callback()
}
function validatePlayButton(rule, value, callback) {
  const { play_button, playable } = this.outterForm
  // 试玩按钮
  if (playable && !play_button) {
    callback(new Error('请选择试玩按钮'))
  }
  callback()
}
function validatePlayableId(rule, value, callback) {
  const { playable_id, playable } = this.outterForm
  // 试玩素材
  if (playable && !playable_id) {
    callback(new Error('请选择试玩素材'))
  }
  callback()
}

function validateDailyBudget(rule, value, callback) {
  const { day_budget, budget } = this.outterForm
  if (budget === 'BUDGET') {
    if (day_budget < 100 || day_budget > 100000000) {
      callback(new Error('每日预算范围 100~100,000,000元'))
    }
  }
  callback()
}

function validateTimeRange(rule, value, callback) {
  const { begin_time, end_time, dateRange } = this.outterForm
  if (dateRange === 'RANGE') {
    if (!begin_time || !end_time) {
      callback(new Error('请设置开始和结束日期'))
    } else if (begin_time < formatDate(new Date(), 'yyyy-MM-dd')) {
      callback(new Error('开始时间不能小于今天'))
    } else if (begin_time > end_time) {
      callback(new Error('结束时间不能晚于开始时间'))
    }
  }
  callback()
}

function getValidtions() {
  const { ocpx_action_type } = this.outterForm
  // 是否行为数优化目标
  const isBehaviorBidType = ocpx_action_type === 2

  // 限制行为数出价0.1 ~ 10
  const maxBid = isBehaviorBidType ? 10 : 10000
  const minBid = isBehaviorBidType ? 0.1 : 1

  return {
    isBehaviorBidType,
    minBid,
    maxBid
  }
}

function validateRangeValue(rule, value, callback) {
  const { budget, day_budget } = this.outterForm
  const { field } = rule

  const { minBid, maxBid } = getValidtions.call(this)

  // 根据prop取到对应的区间值
  let [min, max] = this.outterForm[field] || []
  min = Number(min)
  max = Number(max)

  if (Object.is(min, NaN) || Object.is(max, NaN)) return callback(new Error('请输入数字'))

  const maxValue = Math.max(min, max)
  const minValue = Math.min(min, max)

  if (isEmpty(min) || isEmpty(max)) return callback(new Error('区间值不能为空'))

  if (min > max) return callback(new Error('区间前值不能大于后值'))

  // 不能大于日预算
  if (budget === 'BUDGET' && maxValue > day_budget) {
    return callback(new Error(`区间值不能大于预算值${day_budget}`))
  }

  if (maxValue > maxBid || minValue < minBid) return callback(new Error(`区间范围: ${minBid}~${maxBid}`))

  callback()
}

function validateRangeRoiValue(rule, value, callback) {
  let [min, max] = this.outterForm.roi_ratio_range
  min = Number(min)
  max = Number(max)

  if (isEmpty(min) || isEmpty(max)) return callback(new Error('ROI系数不能为空'))
  if (min > max) return callback(new Error('ROI区间前值不能大于后值'))
  if (min <= 0.001 || max > 100) return callback(new Error('ROI系数范围: 0.001 ~ 100'))
  callback()
}

function validateRoiValue(rule, value, callback) {
  const roi_ratio = this.outterForm.roi_ratio

  if (isEmpty(roi_ratio)) return callback(new Error('ROI系数不能为空'))
  if (roi_ratio <= 0.001 || roi_ratio > 100) return callback(new Error('ROI系数范围: 0.001 ~ 100'))
  callback()
}

function validateBidValue(rule, value, callback) {
  const { budget, day_budget, cpa_bid, bid_range, bid_num_range } = this.outterForm
  const { field } = rule

  // 根据prop取到对应的区间值[cpa_bid | deep_conversion_bid]
  const bidValue = this.outterForm[field]

  const { minBid, maxBid } = getValidtions.call(this)

  // 固定出价和深度出价公共校验
  if (isEmpty(bidValue)) return callback(new Error('出价不能为空'))
  if (bidValue < minBid || bidValue > maxBid) {
    return callback(new Error(`出价范围: ${minBid}~${maxBid} 元`))
  }
  if (budget === 'BUDGET' && day_budget && bidValue && bidValue > day_budget) {
    return callback(new Error(`出价不能大于预算值${day_budget}`))
  }

  // 深度固定出价单独校验
  if (field === 'deep_conversion_bid') {
    if (cpa_bid && cpa_bid >= bidValue) {
      return callback(new Error('深度转化出价应大于目标转化出价'))
    }
    // 目标出价为区间出价
    if (bid_range === 1) {
      const [min, max] = bid_num_range
      if (Math.max(min, max) > bidValue) {
        return callback(new Error('深度转化出价应大于目标转化出价'))
      }
    }
  }

  callback()
}

function validateCreativeTag(rule, value, callback) {
  const { creative_tag } = this.creativeForm
  if (!creative_tag?.length) {
    callback(new Error('请输入创意标签'))
  }
  callback()
}
function validateCode(rule, value, callback) {
  const { code, gift } = this.creativeForm
  if (gift) {
    if (!code) {
      callback(new Error('请输入礼包码'))
    } else {
      const len = getByteLen(code)

      if (len > 20) {
        callback(new Error('最大20个字符，1个中文等于2个字符'))
      }
    }
  }
  callback()
}
function validateSceneId(rule, value, callback) {
  const { scene_id, union, creatives } = this.creativeForm

  if (!creatives?.length) {
    return callback(new Error('创意不能为空'))
  }

  if (!union) {
    if (!scene_id?.length) {
      callback(new Error('请选择场景位置'))
    }
  }
  callback()
}
function nativeIdValidator(rule, value, callback) {
  const { nativeId } = this.creativeForm
  if (!nativeId) {
    callback(new Error('头像与昵称不能为空'))
  }
  callback()
}

export function makeBasicRules() {
  return {
    plan_name: [{ required: true, validator: validateName.bind(this), trigger: 'change' }],
    campaign_id: [{ required: true, validator: validateCampaignId.bind(this), trigger: 'change' }]
  }
}

export function makeAppSettingRules() {
  return {
    landingPage: [{ required: true, validator: validateLandingPage.bind(this) }],
    play_button: [{ required: true, validator: validatePlayButton.bind(this) }],
    playable_id: [{ required: true, validator: validatePlayableId.bind(this) }]
  }
}

export function makeBudgetRules() {
  return {
    dailyBudget: [{ required: true, validator: validateDailyBudget.bind(this) }],
    bidTimeRange: [{ validator: validateTimeRange.bind(this) }],
    cpa_bid: [{ validator: validateBidValue.bind(this) }], // 固定金额
    bid_num_range: [{ validator: validateRangeValue.bind(this) }], // 区间金额
    deep_deepbid_num_range: [{ validator: validateRangeValue.bind(this) }], // 深度优化区间金额
    deep_conversion_bid: [{ validator: validateBidValue.bind(this) }], // 深度优化固定金额
    roi_ratio_range: [{ validator: validateRangeRoiValue.bind(this) }], // roi区间
    roi_ratio: [{ validator: validateRoiValue.bind(this) }] // roi
  }
}

export function makeCreativeRules() {
  return {
    creative_tag: [{ required: true, validator: validateCreativeTag.bind(this), trigger: 'change' }],
    code: [{ required: true, validator: validateCode.bind(this), trigger: 'change' }],
    scene_id: [{ required: true, validator: validateSceneId.bind(this), trigger: 'change' }],
    nativeId: [{ required: true, validator: nativeIdValidator.bind(this), trigger: 'change' }]
  }
}
